import { useEffect, useState } from 'react';

import { useAuth } from '../../../../../Auth';
import { useAxios } from '../../../../../AxiosHandler';

// The pedigree of one dog for PedigreeCard. data is undefined while loading or
// when there is no dog, null when the request failed.
export function usePedigree(animalId: number | undefined, generations: number) {
    const auth = useAuth();
    const axios = useAxios().axios;
    const [data, setData] = useState<any | null | undefined>();

    useEffect(() => {
        setData(undefined);
        if (animalId == undefined) return;
        // Changing generations quickly must not let an older answer win
        let current = true;
        axios.single({
            method: 'get',
            url: `/api/statistics/dog/${animalId}/familytree?generations=${generations}`,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            if (current) setData(res.data ?? null);
        }).catch(() => {
            if (current) setData(null);
        });
        return () => { current = false; };
    }, [animalId, generations]);

    return {
        data: data ?? undefined,
        loading: animalId != undefined && data === undefined,
    };
}
